import React from 'react';
import PropTypes from 'prop-types';
import { AllImageSizes, getImageUrl } from '@domain-group/fe-allhomes-library/lib/enums/image-size';
import * as styles from './development-header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DevelopmentHeader = props => ___EmotionJSX("div", {
  css: styles.header(props.backgroundColour, props.foregroundColour)
}, ___EmotionJSX("div", {
  css: styles.logo,
  style: {
    backgroundImage: "url(".concat(getImageUrl(props.logo, AllImageSizes.NEW_HOMES_LOGO), ")")
  }
}));
DevelopmentHeader.propTypes = {
  backgroundColour: PropTypes.string,
  foregroundColour: PropTypes.string,
  logo: PropTypes.string
};
DevelopmentHeader.defaultProps = {
  backgroundColour: null,
  foregroundColour: null,
  logo: null
};
export default DevelopmentHeader;